import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// New pages open at the top. Back/forward (POP) keeps the browser's own scroll restore.
export default function ScrollToTop() {
    const history = useHistory();

    useEffect(() => {
        let lastPath = history.location.pathname;
        return history.listen((location, action) => {
            if (action !== 'POP' && location.pathname !== lastPath) {
                window.scrollTo(0, 0);
            }
            lastPath = location.pathname;
        });
    }, [history]);

    return null;
}
